import { MAX_EMAIL_LENGTH, FORMBUILDER_ADDRESS, MAX_NAME_LENGTH } from "./index";

export const GENERAL_FORMBUILDER_PATH = 'template.value.formBuilder';

export const FieldCategoryKey = {
  DONATION: 'DONATION'
}

export const customFieldCategory = {
  [FieldCategoryKey.DONATION]: 'donation'
}

export const oldCustomFieldCategory = {
  [FieldCategoryKey.DONATION]: 'Donation'
}

export const nodeTypes = {
  TEXT_INPUT: 'textInput',
  TEXT_AREA: 'textArea',
  DATE: 'date',
  DROPDOWN: 'dropdown',
  CHECKBOX: 'checkbox',
  CONSENT: 'consent',
  PHONE: 'phoneNumber',
  ADDRESS: 'address',
  COUNTRY: 'country',
  TARGET_AMOUNT: 'targetAmount',
  GROUP_DIVIDER: 'groupDivider',
  ADDITIONAL_PHONE: 'additionalPhoneNumber',
  ADDITIONAL_EMAIL: 'additionalEmailAddress',
  ADDITIONAL_FIRST_NAME: 'additionalFirstName',
  ADDITIONAL_LAST_NAME: 'additionalLastName'
};

export const geocodingKeys = {
  STATE: 'administrative_area_level_1 political',
  COUNTRY: 'country political',
  SUBPREMISE: 'subpremise',
  SUBURB: 'locality political',
  POSTCODE: 'postal_code',
  STREET_NUMBER: 'street_number',
  STREET: 'route'
}

export const addresFields = {
  STREET: 'street',
  SUBURB: 'suburb',
  STATE: 'state',
  POSTCODE: 'postCode',
  COUNTRY: 'country'
}

export const specificationOptions = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName'
}

export const TEXT_NODES_MAX_LENGTH = 1000;

export const addressFieldsValidation = {
  [addresFields.STREET]: {
    maxLengthValidation: true,
    maxLength: FORMBUILDER_ADDRESS.STREET_MAX_LENGTH
  },
  [addresFields.SUBURB]: {
    maxLengthValidation: true,
    maxLength: FORMBUILDER_ADDRESS.CITY_MAX_LENGTH
  },
  [addresFields.STATE]: {
    maxLengthValidation: true,
    maxLength: FORMBUILDER_ADDRESS.STATE_MAX_LENGTH
  },
  [addresFields.POSTCODE]: {
    maxLengthValidation: true,
    maxLength: FORMBUILDER_ADDRESS.POST_CODE_MAX_LENGTH
  },
  [addresFields.COUNTRY]: {
    maxLengthValidation: true,
    maxLength: FORMBUILDER_ADDRESS.COUNTRY_MAX_LENGTH
  }
}

export const additionalAnswerValidation = {
  [nodeTypes.TEXT_INPUT]: {
    maxLength: TEXT_NODES_MAX_LENGTH,
    maxLengthValidation: true,
  },
  [nodeTypes.TEXT_AREA]: {
    maxLength: TEXT_NODES_MAX_LENGTH,
    maxLengthValidation: true,
  },
  [nodeTypes.ADDITIONAL_FIRST_NAME]: {
    maxLength: MAX_NAME_LENGTH,
    maxLengthValidation: true,
  },
  [nodeTypes.ADDITIONAL_LAST_NAME]: {
    maxLength: MAX_NAME_LENGTH,
    maxLengthValidation: true,
  },
  [nodeTypes.PHONE]: {
    phone: true,
  },
  [nodeTypes.DATE]: {
    date: true
  },
  [nodeTypes.ADDITIONAL_PHONE]: {
    phone: true
  },
  [nodeTypes.ADDITIONAL_EMAIL]: {
    email: true,
    maxLength: MAX_EMAIL_LENGTH,
    maxLengthValidation: true,
  },
  [nodeTypes.ADDRESS]: {
    formbuilderAddress: true
  }
}

export const TYPE_DOES_NOT_EXIST = "Current type doesn't exist in formbuilder node types: ";

export const GOOGLE_MAPS_STARTING_SEARCH_RADIUS = 20000;